export default __webpack_public_path__ + "static/media/cip-page.a5ef475e.png";